export const view011ImageOptions = {
  angle: 'view011',
  staticOptions: {
    BiminiColor: 1,
    BowOption: 1,
    UpholsteryCockpit: 1,
    AnchorStern: 1,
    AnchorBow: 1,
    Galley: 1
  },
  mattes: [
    {
      option: 'BiminiColor',
      dependency: 'TTop'
    },
    {
      option: 'BowOption',
      dependency: 'UpholsteryCockpit'
    },
    {
      option: 'UpholsteryCockpit',
      dependency: 'TTop'
    },
    {
      option: 'AnchorStern',
      dependency: 'Engine'
    },
    {
      option: 'AnchorBow',
      dependency: 'HullColour'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xpower/views/view011.js